import useStashwiseStore from "@/hooks/useStashwiseStore";
import { LANDING_NAV_ITEMS } from "@/utils/constants";
import { Button } from "@nextui-org/react";
import Image from "next/image";
import Link from "next/link";
import { usePathname } from "next/navigation";
import { useState } from "react";
import { AiOutlineMenu } from "react-icons/ai";

const LandingNavBar = () => {
  const { setMenuOpen, setOpenModal } = useStashwiseStore();
  const pathName = usePathname();
  const [openLegal, setOpenLegal] = useState(false); // Default to false
  const handleLegalToggle = () => setOpenLegal((prev) => !prev);
  const handleLegalMouseEnter = () => setOpenLegal(true);
  const handleLegalMouseLeave = () => setOpenLegal(false);

  return (
    <div className="flex justify-between w-full items-center p-6 lg:px-20 md:px-12 shadow-md shadow-[rgba(0,0,0,0.09)] z-10 fixed top-0 bg-[#ffffff]">
      <Link href="/">
        <Image src="/logo.png" alt="Monietab Logo" width={120} height={50} />
      </Link>

      <AiOutlineMenu
        size={32}
        onClick={() => setMenuOpen(true)}
        className="cursor-pointer md:hidden block"
      />
      <div className="md:flex hidden items-center lg:gap-8 md:gap-6">
        {LANDING_NAV_ITEMS.slice(0, 6).map(({ title, href }, index) => {
          const isActive = pathName.endsWith(href);

          return (
            <div key={index}>
              <Link
                href={href}
                className={`lg:text-lg md:text-base ${
                  isActive && index !== 6 ? "text-primary" : ""
                } ${openLegal && index === 6 ? "text-primary" : ""}`}
                onClick={index === 6 ? handleLegalToggle : undefined}
                onMouseEnter={index === 6 ? handleLegalMouseEnter : undefined}
                onMouseLeave={index === 6 ? handleLegalMouseLeave : undefined}
              >
                {title}
              </Link>

              {index === 6 && openLegal && (
                <div
                  className="absolute bg-[#ffffff] p-4 space-y-2 border text-[#000000]"
                  onMouseEnter={handleLegalMouseEnter}
                  onMouseLeave={handleLegalMouseLeave}
                >
                  {LANDING_NAV_ITEMS.slice(7, 9).map(
                    ({ title, href }, index) => {
                      return (
                        <div
                          key={index}
                          className="flex items-center gap-2 hover:text-primary"
                        >
                          <Link href={href} className="text-sm">
                            {title}
                          </Link>
                          <Image
                            src="/arrowside.svg"
                            alt="icon"
                            width={12}
                            height={12}
                          />
                        </div>
                      );
                    }
                  )}
                </div>
              )}
            </div>
          );
        })}
      </div>

      <Button
        onPress={() => setOpenModal("downloadMobile", true)}
        className="border-[#003471] bg-transparent rounded-[5px] font-semibold border-2 px-10 md:px-12 hover:bg-opacity-80 hover:transition-all duration-300 hidden md:block"
      >
        Download App
      </Button>
    </div>
  );
};

export default LandingNavBar;
